__turbopack_context__.v({
  "byline": "PayloadAccordion-module-scss-module__mp3pmq__byline",
  "container": "PayloadAccordion-module-scss-module__mp3pmq__container",
  "image": "PayloadAccordion-module-scss-module__mp3pmq__image",
  "intro": "PayloadAccordion-module-scss-module__mp3pmq__intro",
  "media": "PayloadAccordion-module-scss-module__mp3pmq__media",
  "reversed": "PayloadAccordion-module-scss-module__mp3pmq__reversed",
});
